<template>
    <div>
        <v-container grid-list-xl fluid>
            <StoreStepper current="static_pages"></StoreStepper>
            <v-form @submit.prevent="handleSubmit">
                <v-layout row wrap class="pt-2">
                    <v-flex sm12>
                        <v-widget :title="`ویرایش `+ form.title">
                            <div slot="widget-content">
                                <v-container>
                                    <v-layout>
                                        <v-text-field
                                                label="عنوان صفحه"
                                                name="title"
                                                v-model="form.title"
                                                type="text"
                                                :rules="[rules.required]"
                                        ></v-text-field>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <VueEditor :useCustomImageHandler="true" @image-added="handleImageAdded" v-model="form.content"></VueEditor>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                    </v-layout>
                                    <v-layout>
                                        <v-btn
                                                :loading="loading"
                                                :disabled="loading"
                                                color="green"
                                                class="white--text"
                                                large
                                                @click="handleSubmit"
                                                type="button"
                                        >
                                            <v-icon right dark>save</v-icon>
                                            &nbsp;
                                            ذخیره

                                        </v-btn>
                                    </v-layout>
                                </v-container>
                            </div>
                        </v-widget>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-container>
        <v-snackbar
                :timeout="snackbar.timeout"
                :color="snackbar.color"
                :top="snackbar.y === 'top'"
                :bottom="snackbar.y === 'bottom'"
                :right="snackbar.x === 'right'"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import { VueEditor } from 'vue2-editor';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import StoreStepper from '@/components/StoreStepper';
export default {
  components: {
    StoreStepper,
    VWidget,
    VueEditor
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      storeUrl: '',
      form: {
        title: '',
        page_id: 0,
        content: '',
        store_id: 0,
      },
      loader: null,
      loading: false,
      rules: {
        required: (value) => !!value || 'پر کردن این فیلد اجباری است.',
      }
    };
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => {
        this[l] = false;
      }, 1000);
      this.loader = null;
    }
  },
  mounted () {

    this.axios.get('/reseller/store_pages/' + this.$route.params.store_id + '?page_id=' + this.$route.params.id)
      .then(response => {
        this.form = response.data.Data[0];
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/stores/?shop_id=' + this.$route.params.store_id)
      .then(response => {
        this.storeUrl = 'https://' + response.data.Data[0].domain;
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

    this.axios.get('/reseller/store_pages/' + this.$route.params.store_id + '?page_id=' + this.$route.params.id)
      .then(response => {
        this.form = response.data.Data[0];
      })
      .catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });

  },
  methods: {
    handleSubmit () {
      this.$validator.validateAll().then((isValidate) => {
        if (isValidate) {
          this.axios.put('/reseller/store_pages/' + this.$route.params.id, this.form)
            .then(response => {
              // Response Submit Method
              console.log(response);
              this.snackbar.text = 'با موفقیت انجام شد.';
              this.snackbar.y = 'bottom';
              this.snackbar.color = 'success';
              this.snackbar.snackbar = true;
              this.loading = false;
            })
            .catch(error => {
              this.snackbar = HttpErrorToSnackbar(error);
              this.loading = false;
            });
        }
      });
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      let formData = new FormData();
      formData.append('file', file);
      this.axios({
        url: '/reseller/upload_assets',
        method: 'POST',
        data: formData
      })
        .then(result => {
          let url = this.storeUrl + '/assets/' + result.data.name;
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        })
        .catch(err => {
          this.snackbar = HttpErrorToSnackbar(err);
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/static_pages/edit.vue